import React, { useState, useEffect } from "react";
import { Form, Button, Table, Modal, Card, Row, Col } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../../api/api";
import axios from "axios";
import CardLayout from "../Layout/CardLayout";
import Ranked from "../Ciem/Ranked";
import InputMask from "react-input-mask";

const ContributionForm = (ciemId) => {
    const [formData, setFormData] = useState({
        pais: "",
        ciudad: "",
        moneda: "",
        tasaCambio: "",
        ciemId: ciemId.ciemId,
        detailContributionDTOList: [],
        totalPvupp: 0,
        totalCvupp: 0,
        totalMcupp: 0,
        porcentajemcupp: 0,
    });
    const [rankedForm, setRankedForm] = useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [infoModal, setInfoModal] = useState({ show: false, content: '' });
    const [countriesData, setCountriesData] = useState([]);
    const [citiesData, setCitiesData] = useState([]);

    useEffect(() => { // Reemplaza con la URL de tu API de títulos

        axios.get('https://restcountries.com/v3.1/all?fields=name,capital,currencies,subregion').then((response) => {
            const sortedCountries = response.data.sort((a, b) => a.name.common.localeCompare(b.name.common));
            setCountriesData(sortedCountries);
        }).catch((e) => {
            console.error("Error fetching countries:", e);
        });

        axiosInstance.get('/detailoption/option/value/contributionTable').then((response) => {
            setTableHeaders(response.data.data);
            console.log("tabla contribution" + tableHeaders)
        }).catch((e) => {
            alert("Error consultando la tabla " + e)
        });

        axiosInstance.get('/contribution/' + ciemId.ciemId).then((response) => {
            if (response) {
                setFormData(response.data.data);
            }
            console.log("informacion guardada" + formData)
        }).catch((e) => {
            // Solo mostrar error si NO es 404 (404 significa que no hay datos aún, lo cual es normal)
            if (e.response && e.response.status !== 404) {
                alert("Error consultando la tabla " + e)
            }
        });

        axiosInstance.get('/detailoption/option/value/rankedFour').then((response) => {
            console.log("Calificación obtenida:", response.data.data[0]);
            setRankedForm(response.data.data[0]);
        }).catch((e) => {
            alert("Error consultando la calificacion " + e)
        });

    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleCountryChange = (e) => {
        const selectedPaisName = e.target.value;
        const selectedCountry = countriesData.find(c => c.name.common === selectedPaisName);

        let newCiudad = formData.ciudad;
        let newMoneda = formData.moneda;

        if (selectedCountry) {
            if (selectedCountry.capital && selectedCountry.capital.length > 0) {
                newCiudad = selectedCountry.capital[0];
            }
            if (selectedCountry.currencies) {
                const currencyKeys = Object.keys(selectedCountry.currencies);
                if (currencyKeys.length > 0) {
                    newMoneda = currencyKeys[0];
                }
            }

            // Buscar ciudades por la subregión del país usando la API solicitada
            if (selectedCountry.subregion) {
                axios.get(`https://restcountries.com/v3.1/subregion/${selectedCountry.subregion}`)
                    .then(response => {
                        // Extraemos las capitales de los países de esa subregión para usarlas como opciones de ciudad
                        const cities = response.data
                            .map(country => country.capital ? country.capital[0] : null)
                            .filter(city => city !== null);

                        // Opcionalmente podemos ordenar alfabéticamente
                        cities.sort((a, b) => a.localeCompare(b));
                        setCitiesData(cities);
                    })
                    .catch(err => {
                        console.error("Error fetching cities by subregion:", err);
                        setCitiesData([]);
                    });
            } else {
                setCitiesData([]);
            }
        } else {
            setCitiesData([]);
        }

        setFormData({
            ...formData,
            pais: selectedPaisName,
            ciudad: newCiudad,
            moneda: newMoneda,
        });
    };

    const handleDetailChange = (index, field, value) => {
        console.log("cuando edita")
        console.log(field)
        console.log(value)
        const newDetails = [...formData.detailContributionDTOList];
        newDetails[index][field.value] = value;
        setFormData({ ...formData, detailContributionDTOList: newDetails });
        console.log("formulario final")
        console.log(formData)
        axiosInstance.post('/contribution/calculate', formData).then((response) => {
            //setTableHeaders(response.data.data);
            console.log("respuesta c")
            setFormData(response.data.data)
        }).catch((e) => {
            alert("Error de calculo " + e)
        });

    };

    const addDetailRow = () => {
        setFormData({
            ...formData,
            detailContributionDTOList: [...formData.detailContributionDTOList, {}],
        });
    };

    const removeDetailRow = async (index) => {
        const detail = formData.detailContributionDTOList[index];

        // Si la fila tiene id guardado en backend, verificar existencia antes de eliminar
        if (detail && detail.id) {
            try {
                await axiosInstance.get(`/detailcontribution/${detail.id}`);
                // Existe en backend → eliminar via API
                if (!window.confirm('¿Está seguro de que desea eliminar este registro?')) return;
                await axiosInstance.delete(`/detailcontribution/${detail.id}`);
                alert('Registro eliminado correctamente');
                // Refrescar datos desde el servidor
                axiosInstance.get('/contribution/' + ciemId.ciemId).then((response) => {
                    if (response) setFormData(response.data.data);
                }).catch(() => { });
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // No existe en backend → eliminar solo del estado local
                    const newDetails = formData.detailContributionDTOList.filter((_, i) => i !== index);
                    setFormData({ ...formData, detailContributionDTOList: newDetails });
                } else {
                    const msg = error.response?.data?.message || error.message;
                    alert('Error al eliminar: ' + msg);
                    console.error('Error eliminando detailcontribution:', msg);
                }
            }
        } else {
            // Fila nueva sin id → eliminar solo del estado local
            const newDetails = formData.detailContributionDTOList.filter((_, i) => i !== index);
            setFormData({ ...formData, detailContributionDTOList: newDetails });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
        axiosInstance.post('/contribution/', formData).then((response) => {
            alert("Datos guardados correctamente");
            console.log("respuesta guardado")
            setFormData(response.data.data)
        }).catch((e) => {
            alert("Error guardando la información " + e)
        });;
    };

    const contributionForm = <Form onSubmit={handleSubmit}>
        <Row>
            <Col md={6}>
                <Form.Group controlId="pais">
                    <Form.Label>País</Form.Label>
                    <Form.Control
                        type="text"
                        name="pais"
                        list="countries-list"
                        value={formData.pais || ""}
                        onChange={handleCountryChange}
                        autoComplete="off"
                    />
                    <datalist id="countries-list">
                        {countriesData.map((country, idx) => (
                            <option key={idx} value={country.name.common} />
                        ))}
                    </datalist>
                </Form.Group>
            </Col>

            <Col md={6}>
                <Form.Group controlId="ciudad">
                    <Form.Label>Ciudad</Form.Label>
                    <Form.Control
                        type="text"
                        name="ciudad"
                        list="cities-list"
                        value={formData.ciudad || ""}
                        onChange={handleChange}
                        autoComplete="off"
                    />
                    <datalist id="cities-list">
                        {citiesData.map((city, idx) => (
                            <option key={idx} value={city} />
                        ))}
                    </datalist>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={6}>
                <Form.Group controlId="moneda">
                    <Form.Label>Moneda</Form.Label>
                    <Form.Control
                        type="text"
                        name="moneda"
                        value={formData.moneda || ""}
                        onChange={handleChange}
                    />
                </Form.Group>
            </Col>

            <Col md={6}>
                <Form.Group controlId="tasaCambio">
                    <Form.Label>Tasa de Cambio</Form.Label>
                    <Form.Control
                        type="text"
                        name="tasaCambio"
                        value={formData.tasaCambio || ""}
                        onChange={handleChange}
                    />
                </Form.Group>
            </Col>
        </Row>
        <p></p>
        <h3>Detalles de Contribución</h3>
        <Button variant="success" onClick={addDetailRow}>
            Agregar Fila
        </Button>
        <Table striped bordered hover>
            <thead>
                <tr>
                    {tableHeaders.map((titulo) => (
                        <th key={titulo.id}>
                            <span className="d-flex align-items-center gap-1">
                                {titulo.description}
                                {titulo.tooltip && (
                                    <Button
                                        variant="link"
                                        size="sm"
                                        className="p-0 text-info"
                                        onClick={() => setInfoModal({ show: true, content: titulo.tooltip })}
                                        title="Ver información"
                                    >
                                        <FontAwesomeIcon icon={faInfoCircle} />
                                    </Button>
                                )}
                            </span>
                        </th>
                    ))}
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                {formData.detailContributionDTOList.map((detail, index) => (
                    <tr key={index}>
                        {tableHeaders.map((header, idx) => (
                            <td key={idx}>
                                {!header.editable ? (
                                    // Mostrar como texto plano si no es editable
                                    <span className="form-control-plaintext" style={{ minWidth: 150 }}>{detail[header.value] || ""}</span>
                                ) : header.type === "text" ? (
                                    <Form.Control
                                        type="text"
                                        value={detail[header.value] || ""}
                                        onChange={(e) => handleDetailChange(index, header, e.target.value)}
                                        style={{ minWidth: 150 }}
                                    />
                                ) : (
                                    <InputMask
                                        mask="99999999.99"
                                        maskChar=""
                                        value={detail[header.value] || ""}
                                        onChange={(e) => handleDetailChange(index, header, e.target.value)}
                                    >
                                        {(inputProps) => <Form.Control type="text" {...inputProps} style={{ minWidth: 150 }} />}
                                    </InputMask>
                                )}
                            </td>
                        ))}
                        <td>
                            <Button variant="danger" onClick={() => removeDetailRow(index)}>
                                Eliminar
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <p></p>
        <h3>Totales</h3>
        <Table striped bordered>
            <tbody>
                <tr>
                    <td>Total PVUPP</td>
                    <td>{formData.totalPvupp}</td>
                </tr>
                <tr>
                    <td>Total CVUPP</td>
                    <td>{formData.totalCvupp}</td>
                </tr>
                <tr>
                    <td>Total MCUpp</td>
                    <td>{formData.totalMcupp}</td>
                </tr>
                <tr>
                    <td>Porcentaje MCUpp</td>
                    <td>{formData.porcentajemcupp}</td>
                </tr>
            </tbody>
        </Table>

        <Button variant="primary" type="submit">
            Guardar
        </Button>
    </Form>;

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId.ciemId} />

    return (
        <div className="container-fluid">
            <CardLayout value={"contributionTitulo"} tablaComponent={contributionForm} />
            <CardLayout value={"rankedFour"} tablaComponent={calificacion} />

            {/* Modal de información de columnas */}
            <Modal show={infoModal.show} onHide={() => setInfoModal({ show: false, content: '' })} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Información</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{ __html: infoModal.content }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setInfoModal({ show: false, content: '' })}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ContributionForm;
